import React, { useState } from 'react';
import { T, LOGO_CONFIG } from '../utils/theme';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const { login, loading, error: authError } = useAuth();
  const { carregarDados } = useData();
  const [localError, setLocalError] = useState('');

  const handleSubmit = async () => {
    setLocalError('');
    if (!email || !senha) { setLocalError('Preencha todos os campos'); return; }
    const success = await login(email, senha);
    if (success) {
      await carregarDados();
      setEmail(''); setSenha('');
    } else {
      setLocalError(authError || 'Email ou senha invalidos');
    }
  };

  const errorMessage = localError || authError;

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'radial-gradient(1200px 700px at 20% 0%, rgba(10,132,255,0.12), transparent 60%), radial-gradient(1000px 600px at 85% 30%, rgba(191,90,242,0.08), transparent 60%), linear-gradient(180deg, #0A0A0C 0%, #060608 100%)',
    }}>
      <div style={{
        background: 'rgba(28,28,30,0.7)',
        backdropFilter: 'blur(40px) saturate(180%)', WebkitBackdropFilter: 'blur(40px) saturate(180%)',
        border: '0.5px solid rgba(255,255,255,0.1)',
        borderRadius: 28, padding: 32, width: '100%', maxWidth: 400,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <div className="text-center" style={{ marginBottom: 32 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 18, background: '#fff',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 16, boxShadow: '0 8px 32px rgba(10,132,255,0.25)',
          }}>
            <img src={LOGO_CONFIG.url} alt="Barbx" style={{ width: 40, height: 40, objectFit: 'contain' }}
              onError={(e) => { e.target.style.display = 'none'; }} />
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 700, color: '#fff', letterSpacing: '-0.025em' }}>Barbx Pro</h1>
          <p style={{ fontSize: 14, color: 'rgba(235,235,245,0.6)', marginTop: 6 }}>Plataforma de gestao para barbearias</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(235,235,245,0.6)', marginBottom: 6 }}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()} disabled={loading}
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 14,
                background: 'rgba(255,255,255,0.08)', border: '0.5px solid rgba(255,255,255,0.12)',
                color: '#fff', fontSize: 16, fontFamily: 'inherit', outline: 'none',
              }}
              placeholder="gestor@barbearia.com" />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(235,235,245,0.6)', marginBottom: 6 }}>Senha</label>
            <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()} disabled={loading}
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 14,
                background: 'rgba(255,255,255,0.08)', border: '0.5px solid rgba(255,255,255,0.12)',
                color: '#fff', fontSize: 16, fontFamily: 'inherit', outline: 'none',
              }}
              placeholder="••••••••" />
          </div>
          {errorMessage && (
            <div style={{ background: 'rgba(255,59,48,0.15)', color: T.danger, padding: '12px 16px', borderRadius: 14, fontSize: 14, fontWeight: 500 }}>
              {errorMessage}
            </div>
          )}
          <button onClick={handleSubmit} disabled={loading} style={{
            width: '100%', padding: 15, borderRadius: 16, border: 'none',
            background: T.accent, color: '#fff', fontSize: 16, fontWeight: 600,
            fontFamily: 'inherit', cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1, boxShadow: '0 6px 20px rgba(10,132,255,0.4)',
            letterSpacing: '-0.01em',
          }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
